import * as Yup from 'yup';
import { wgs84CoordinatesSchema } from '../../components/form/address-field/address-field-schema';
import { MinimalDistances } from '../../models';

export function useValidationSchema() {
  return Yup.object<MinimalDistances>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    sourceId: Yup.string().nullable().required('Povinné pole'),
    sourceCategory: Yup.object().nullable().required('Povinné pole'),
    determinationMethod: Yup.object().nullable().required('Povinné pole'),
    ovzFacility: Yup.object().nullable().required('Povinné pole'),
    wgs84Coordinates: wgs84CoordinatesSchema(),
  }) as Yup.Schema<MinimalDistances>;
}
